<mat-menu #childMenu="matMenu" [overlapTrigger]="false">
  @for (child of items; track child) {
    @if (child.children) {
      <button mat-menu-item color="primary" [matMenuTriggerFor]="menu.childMenu">
        <span class="pe-2">
          <app-menu-item-display-value [item]="child" />
        </span>
      </button>

      <app-menu-item #menu [items]="child.children" />
    } @else {
      <a mat-menu-item [routerLink]="child.route" [queryParams]="child.queryParams">
        <span class="pe-2 me-3">
          <app-menu-item-display-value [item]="child" />
        </span>
      </a>
    }
  }
</mat-menu>
